import { Injectable, Injector } from '@angular/core';
import { NavigationService } from '../../modules/tcm-core.module';
import { LoginComponent } from 'src/app/components/login/login.component';
import { SingletonCheckHelper } from '../../helpers/singleton-check.helper';
import { ReturnUrlInfo } from '../../internals/return-url-info';
import { TcmModalService } from '../../modules/tcm-common/services/tcm-modal.service';

@Injectable()
export class LoginComponentService {

    get isLoginDisplaying() {
        return LoginComponent.instance != null;
    }

    constructor(private readonly injector: Injector) {
        SingletonCheckHelper.ensureSingleton(this);
    }

    navigateToLogin(returnUrl?: ReturnUrlInfo): Promise<boolean> {
        const nav = this.injector.get(NavigationService);        

        return nav.navigate('/login', returnUrl, { replaceUrl: true });
    }

    openLoginModal() {
        if (LoginComponent.instance)
            return null;

        const modalService : TcmModalService = this.injector.get(TcmModalService);

        return modalService.openComponentInModal(LoginComponent, 'lg', null, 'login-modal');
    }

    closeLogin() {
        if (!LoginComponent.instance)
            return;

        LoginComponent.instance.close();
    }
}
